import React from 'react'

const IconScales = ({ modifiers, height }) => {
  return (
    <svg
      className={`icon icon-scales ${modifiers}`}
      style={{height}}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 100.9 84.7"
    >
    <circle fill="none" cx="50.3" cy="46" r="38.8"/>
    <path d="M97.8,31.9L86.4,4.5c0.7,0,1.3-0.1,1.9-0.1c1.2,0,2.2-1,2.2-2.2S89.6,0,88.4,0C72.2,0,55.7,5.2,50.5,5.2
      C45.3,5.2,28.8,0,12.5,0c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c0.6,0,1.2,0,1.8,0.1L3,31.9H0c0,8.7,7.1,15.8,15.8,15.8
      s15.8-7.1,15.8-15.8h-3.1L17.2,4.7c12.6,1.5,28.7,8.2,33.3,8.2h0c4.6,0,20.6-6.6,33.2-8.2L72.4,31.9h-3c0,8.7,7.1,15.8,15.8,15.8
      s15.8-7.1,15.8-15.8H97.8z M2.5,35.3c1.3,0,3.4,0.7,4.1,1.8c1.9,3,3.8,4.3,7.2,5.5c1,0.3,1.7,2.3,1.7,3.3
      C9.4,45.1,4.4,40.9,2.5,35.3z M27,31.9H4.4L15.7,4.6c0,0,0,0,0.1,0L27,31.9z M71.9,35.3c1.3,0,3.4,0.7,4.1,1.8
      c1.9,3,3.8,4.3,7.2,5.5c1,0.3,1.7,2.3,1.7,3.3C78.8,45.1,73.8,40.9,71.9,35.3z M73.7,31.9L85,4.6c0,0,0,0,0.1,0l11.3,27.3H73.7z"/>
    <g>
      <path d="M50.5,84.1c11.7,0,22.3-5.1,29.5-13.2c-5.1-11.3-16.4-9.1-29.5-9.1c-13.2,0-24.5-2.1-29.5,9.1
        C28.2,79,38.7,84.1,50.5,84.1z"/>
    </g>
    <path d="M50.5,31.9c0.7,0,1.7-0.1,2.8-0.3c0-1.2,0-2.4,0-3.6c0-1.5-1.2-2.8-2.8-2.8c-1.5,0-2.8,1.2-2.8,2.8
      c0,1.2,0,2.4,0,3.6C48.8,31.8,49.7,31.9,50.5,31.9z"/>
    <path d="M50.5,58.1c5.1,0,10-0.3,14.3-0.1v-2.5c0-2-1.6-3.6-3.6-3.6H39.8c-2,0-3.6,1.6-3.6,3.6v2.5
      C40.5,57.8,45.3,58.1,50.5,58.1z"/>
    <path d="M50.5,16.5L50.5,16.5c-0.8,0-1.9-0.2-3.3-0.5c-0.8,14.2-2.3,24.7-2.5,32.4h11.7C56,40.7,54.5,30.2,53.7,16
      C52.4,16.3,51.2,16.5,50.5,16.5z"/>
    </svg>
  )
}

IconScales.defaultProps = {
  height: "5rem",
  modifiers: ""
}

export default IconScales
